import { variant } from 'styled-system'
import colors from '../../constants/colors'

const labelVariant = variant({
  prop: 'variant',
  variants: {
    error: {
      backgroundColor: colors.red5,
      color: colors.red50,
      svg: {
        path: {
          fill: colors.red50,
        },
      },
    },
    success: {
      backgroundColor: colors.blue5,
      color: colors.blue50,
      svg: {
        path: {
          fill: colors.blue50,
        },
      },
    },
    neutral: {
      backgroundColor: colors.black5,
      color: colors.black50,
      svg: {
        path: {
          fill: colors.black50,
        },
      },
    },
    warning: {
      backgroundColor: colors.yellow5,
      color: colors.yellow50,
      svg: {
        path: {
          fill: colors.yellow50,
        },
      },
    },
    none: {
      backgroundColor: 'none',
    },
  },
})

export { labelVariant }
